export const eSimConstants = {
    registrationTypeOperation: 'registration',
    portabilityTypeOperation: 'portability',
    defaultRateEsimSelected: 'mundo'
};